import { EntityActions } from '~/apps/shared/actions/consts';
import { AdditionalFieldActions } from '../actions/consts';
import { AdditionalFieldItem } from '../../models';


type AdditionalFieldUIState = {
  currentList: [],
  loading: false,
  errorMessage: string,
  currentPage: number,
};

type AdditionalFieldState = {
  entities: {[id: string]: AdditionalFieldItem},
  ui: AdditionalFieldUIState,
};

const defaultState: AdditionalFieldState = {
  entities: {},
  ui: {
    currentList: [],
    loading: false,
    errorMessage: '',
    currentPage: 0,
  }
};

export function fields(state: AdditionalFieldState = defaultState, action) {
  switch (action.type) {
    case EntityActions.ADD_ENTITIES:
      return {
        ...state,
        entities: {
          ...state.entities,
          ...action.entities.fields,
        }
      };
    case AdditionalFieldActions.LOAD_REQUEST:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: true,
          errorMessage: '',
        }
      };
    case AdditionalFieldActions.LOAD_SUCCESS:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          errorMessage: '',
        }
      };
    case AdditionalFieldActions.LOAD_ERROR:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          errorMessage: action.error.errorMessage,
        }
      };
    case AdditionalFieldActions.LOAD_LIST_SUCCESS:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          errorMessage: '',
          currentList: action.result,
        }
      };
    case AdditionalFieldActions.SET_CURRENT_PAGE:
      return {
        ...state,
        ui: {
          ...state.ui,
          currentPage: action.currentPage,
        }
      };
    default:
      return state;
  }
}
